import MentoringNumberIcon from './MentoringNumberIcon.vue';

export default MentoringNumberIcon;



// WEBPACK FOOTER //
// ./src/pages/profile/modules/mentoring/process/components/number/components/numbericon/index.ts